/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Launch_NavInputs */

const en_how_we_work_launch_nav = /** @type {(inputs: How_We_Work_Launch_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring the team along`)
};

const lv_how_we_work_launch_nav = /** @type {(inputs: How_We_Work_Launch_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iesaistām komandu`)
};

/**
* | output |
* | --- |
* | "Bring the team along" |
*
* @param {How_We_Work_Launch_NavInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_launch_nav = /** @type {((inputs?: How_We_Work_Launch_NavInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Launch_NavInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_launch_nav(inputs)
	return en_how_we_work_launch_nav(inputs)
});